import { render, staticRenderFns } from "./AddWidget.vue?vue&type=template&id=3e154e66&scoped=true"
import script from "./AddWidget.vue?vue&type=script&lang=js"
export * from "./AddWidget.vue?vue&type=script&lang=js"
import style0 from "./AddWidget.vue?vue&type=style&index=0&id=3e154e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e154e66",
  null
  
)

export default component.exports